import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categorias" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-300/60 mb-5">
            <span className="text-xs font-medium text-foreground-600 tracking-wide">Categorias</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Encontre Seu
            <br />
            <span className="font-heading italic font-normal text-foreground-700">Produto</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            Explore todas as categorias de produtos disponíveis na nossa CSSBuy Spreadsheet atualizada.
          </p>
        </div>

        {/* Grid with images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl border border-background-200/70 bg-background-50 hover:border-primary-300 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* Category Image */}
              <div className="relative h-[160px] md:h-[180px] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - CSSBuy Spreadsheet`}
                  title={`${cat.name} - Produtos na CSSBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-4 md:p-5 -mt-1 relative z-10 bg-background-50">
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-background-100 text-foreground-500 group-hover:bg-primary-500 group-hover:text-white transition-colors mb-3">
                  <i className={`${cat.icon} text-base`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  Explorar
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}